import { CopyTileContextProvider } from 'app/src/editor/CopyTileContext';
import Tile from 'app/src/engine/tiles/Tile';
import * as React from 'react';

const MAX_COPIED_TILES = 6;

type Props = {
	children: React.ReactNode;
};

export default function CopyTileController({ children }: Props): React.ReactElement {
	const [copiedTiles, setCopiedTiles] = React.useState<Tile[]>([]);

	const addTile = (tile: Tile): void => {
		// Make a copy of the tiles list.
		const newTiles = [tile, ...copiedTiles.filter((t) => !t.isEqualTo(tile))];

		// Trim the copied tiles to the max count.
		if (newTiles.length > MAX_COPIED_TILES) {
			newTiles.splice(MAX_COPIED_TILES, newTiles.length - MAX_COPIED_TILES);
		}

		// Save back the tiles.
		setCopiedTiles(newTiles);
	};

	return (
		<CopyTileContextProvider
			value={{
				copiedTiles,
				addTile,
			}}
		>
			{children}
		</CopyTileContextProvider>
	);
}
